import Api from '@/services/api-service'

export default {
  state: {
    is_auth: false,
    user: false
  },
  mutations: {
    SET_IS_AUTH: function (state, is_auth) {
      state.is_auth = is_auth
    },
    SET_AUTH: function (state, auth) {
      state.user = auth
    }
  },
  actions: {
    fetchAuth ({
      commit
    }, auth) {
      console.log(auth)
      if (auth) {
        var is_auth = true
      } else {
        var is_auth = false
      }
      commit('SET_IS_AUTH', is_auth)
      commit('SET_AUTH', auth)
    }
  },
  getters: {

  }
}
